import type { GuidedProcedure } from '@padcanvas/shared';
import type { SimulationListing } from './types';

/**
 * A guided experiment as a card of the simulations gallery — the way zitmus
 * shelves the two kinds together. Admin lists both on one page; the student
 * app's experiments page lists only these. The same card either way.
 *
 * `thumbnailUrl` is resolved by the caller, because only the caller knows
 * where its screenshots are served from. With none, the card falls back to the
 * experiment's equation, then its glyph.
 */
export function experimentListing(
  e: GuidedProcedure & { moduleIds: string[]; status?: 'live' | 'draft' },
  thumbnailUrl: string | undefined,
): SimulationListing {
  const steps = `${e.steps.length} ${e.steps.length === 1 ? 'step' : 'steps'}`;
  return {
    id: e.id,
    title: e.title,
    tagline: e.tagline,
    description: e.description,
    subject: e.subject,
    topic: 'Guided experiment',
    parameters: [],
    detail: e.mode === 'quantitative' ? `${steps} · with amounts` : steps,
    moduleIds: e.moduleIds,
    assetUrl: '',
    thumbnailUrl,
    equation: e.equation,
    accentColor: e.accentColor,
    glyph: e.glyph,
    status: e.status ?? 'live',
  };
}
